var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgProfile(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M15.9261 18.0557C18.397 16.235 20 13.3047 20 10C20 4.47715 15.5228 0 10 0C4.47715 0 0 4.47715 0 10C0 13.3047 1.60301 16.235 4.07388 18.0557C4.08708 18.0654 4.1003 18.0751 4.11354 18.0848C4.46109 18.3383 4.8256 18.5699 5.20506 18.7776C6.62867 19.5569 8.26259 20 10 20C11.7374 20 13.3713 19.5569 14.7949 18.7776C14.8209 18.7634 14.8467 18.7491 14.8725 18.7347C15.2385 18.5301 15.5903 18.3031 15.9261 18.0557ZM15.5844 16.8015C17.5479 15.1876 18.8002 12.74 18.8002 10C18.8002 5.13989 14.8603 1.2 10.0002 1.2C5.14009 1.2 1.2002 5.13989 1.2002 10C1.2002 12.7399 2.45236 15.1873 4.41566 16.8013C5.03387 15.2324 6.29412 13.9868 7.87271 13.388C6.74765 12.6802 6 11.4274 6 10C6 7.79086 7.79086 6 10 6C12.2091 6 14 7.79086 14 10C14 11.4274 13.2523 12.6802 12.1273 13.388C13.706 13.9868 14.9663 15.2325 15.5844 16.8015ZM14.5684 17.5229C13.9454 15.5947 12.1356 14.2 10 14.2C7.86449 14.2 6.05469 15.5946 5.43164 17.5227C6.76335 18.3332 8.32726 18.8 10.0002 18.8C11.673 18.8 13.2368 18.3333 14.5684 17.5229ZM12.8 10C12.8 11.5464 11.5464 12.8 10 12.8C8.4536 12.8 7.2 11.5464 7.2 10C7.2 8.4536 8.4536 7.2 10 7.2C11.5464 7.2 12.8 8.4536 12.8 10Z",
    fill: "#DEE2E2"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgProfile);
export default __webpack_public_path__ + "static/media/profile.200b8cbe1f1274cb0a79bccfc1b5ab33.svg";
export { ForwardRef as ReactComponent };